module.exports = __webpack_public_path__ + "static/media/Cheaeh.b546ee2c.jpg";